import { Injectable, inject } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { PersonService } from '../../service/person.service';
import { Store } from '@ngrx/store';

@Injectable()
export class PersonEffects {
    private readonly actions$ = inject(Actions);
    private readonly api = inject(PersonService);
    private readonly store = inject(Store);


}
